import React from 'react';
import services_main from '../assets/images/Services.jpg';
import '../styles/Services.css';
import '../styles/Home.css';
import luxuryProperty from '../assets/images/services/Services - Luxury Property.jpg';
import propertyInvestment from '../assets/images/services/Services - Property Investment Consultancy.jpg';
import offPlan from '../assets/images/services/Services - Off Plan.jpg';
import propertyManagement from '../assets/images/services/Services - Property Management.jpg';
import mortgageFinance from '../assets/images/services/Services - Mortgage and Finance Services.jpg';
import TalkExpertSection from '../components/TalkExpertSection';
import ScrollDownArrow from '../components/ScrollDownArrow';

const services = [
  {
    title: "Luxury Property Sourcing",
    description: "Curating Dubai's Most Exclusive Properties For Discerning Investors. From opulent beachfront villas to sky-high penthouses commanding breathtaking views, ABBASS Global Properties opens doors to Dubai's most coveted real estate opportunities. Save boutique approach combines deep market intelligence with white-glove service, ensuring each property acquisition perfectly aligns with your investment vision and lifestyle aspirations.",
    image: luxuryProperty,
  },
  {
    title: "Property Investment Consultancy",
    description: "Premium Investment Opportunities Through Data-Driven Excellence. Understand Dubai's dynamic real estate landscape with unparalleled market intelligence and strategic foresight. At ABBASS Global Properties, we transform complex market data into actionable investment opportunities, empowering you to make decisions that align with your wealth creation objectives.",
    image: propertyInvestment,
  },
  {
    title: "Off - Plan Property Sales",
    description: "Dubai's Most Exclusive Off-Plan Opportunity: Your Early Access Advantage. Through strategic alliances with Dubai's elite city developers, ABBASS Global Properties offers privileged access to the top stock of much-anticipated real estate launches. Our partners deliver premier opportunities within a network of exclusive pre-launch opportunities, from limited selection villas to signature penthouses, before they reach the broader market.",
    image: offPlan,
  },
  {
    title: "Property Management",
    description: "Buy With Confidence Knowing Your Property Will Be Fully Managed. Buy with confidence knowing that your investment will be fully managed post handover. We offer tailored Property Management options that yield serious returns, hassle-free and suited to every asset plan. Our experienced team is here to guide you on the best strategy and point of contact if you are an investor looking to lease out your property.",
    image: propertyManagement,
  },
  {
    title: "Mortgage & Finance Service",
    description: "Premium Property Finance Through Strategic Excellence. ABBASS Global Properties complements your property acquisition journey with unparalleled financing expertise. As experienced financial architects, we collaborate with the UAE's most prestigious banking institutions to craft mortgage solutions that transcend conventional boundaries, designed exclusively for sophisticated investors and home owners.",
    image: mortgageFinance,
  },
];

const Services = () => (
  <div className="services-page">
    <div className="services-hero-section" style={{backgroundImage: `url(${services_main})`}}>
      <div className="services-hero-overlay"></div>
      <h1 className="services-hero-title">Services</h1>
      <p className="services-hero-subtitle">Discover our full suite of real estate services, designed to guide you through every step of your property journey in Dubai.</p>
      <ScrollDownArrow targetSelector=".services-list-section" />
    </div>
    <section className="services-list-section">
      <div className="container">
        {services.map((service, idx) => (
          <div className="services-list-row" key={idx}>
            <div className="services-list-content">
              <h2 className="services-list-title">{service.title}</h2>
              <p className="services-list-description">{service.description}</p>
            </div>
            <div className="services-list-image">
              <img src={service.image} alt={service.title} />
            </div>
          </div>
        ))}
        
        <TalkExpertSection />
      </div>
    </section>
  </div>
);

export default Services; 